import { FormattedMessage } from 'react-intl';
import { isNil } from 'lodash';
import { fromJS } from 'immutable';

// COMPONENTS
import DropdownMenu from 'components/DropdownMenu';

// STYLES
import { TextAddition } from './styles';

const FrequencyItemDropdown = (props) => {
  if (props.visible !== true) {
    return null;
  }

  const { name, onSelectOption, translations } = props;

  const handleSelectOption = (value) => () => {
    onSelectOption(name, value);
  };

  const dropdownOptions = fromJS(
    props.options.map((option) => ({
      id: option,
      renderedValue: translations ? { translationId: translations[option] } : option,
      handleClick: handleSelectOption(option),
    }))
  );

  let textBefore = null;
  let textAfter = null;

  if (!isNil(props.textBefore)) {
    textBefore = (
      <TextAddition>
        <FormattedMessage id={String(props.textBefore)} />
      </TextAddition>
    );
  }

  if (!isNil(props.textAfter)) {
    textAfter = (
      <TextAddition>
        <FormattedMessage id={String(props.textAfter)} />
      </TextAddition>
    );
  }

  const renderedValue = translations ? { translationId: translations[props.selected] } : props.selected;

  return (
    <div>
      {textBefore}
      <DropdownMenu {...props} renderedValue={renderedValue} items={dropdownOptions} button />
      {textAfter}
    </div>
  );
};

FrequencyItemDropdown.defaultProps = {
  visible: true,
  textBefore: null,
  textAfter: null,
  translations: null,
  top: false,
};

export default FrequencyItemDropdown;
